import { useNavigate } from "react-router-dom";

import Card from "../../common/Card/Card";
import Button from "../../common/Button/Button";

import {
    UserCheck,
    Bike,
} from "lucide-react";

import "./PendingProviders.css";

function PendingProviders({ dashboard = {} }) {

    const navigate = useNavigate();

    const pendingProviders =
        dashboard.pendingProviders || 0;

    const pendingDeliveryPartners =
        dashboard.pendingDeliveryPartners || 0;

    const totalPending =
        pendingProviders +
        pendingDeliveryPartners;

    return (

        <Card title="Pending Approvals">

            <div className="approval-list">

                <div className="approval-item">

                    <div className="approval-left">

                        <UserCheck size={22} />

                        <span>

                            Providers

                        </span>

                    </div>

                    <strong>

                        {pendingProviders}

                    </strong>

                </div>

                <div className="approval-item">

                    <div className="approval-left">

                        <Bike size={22} />

                        <span>

                            Delivery Partners

                        </span>

                    </div>

                    <strong>

                        {pendingDeliveryPartners}

                    </strong>

                </div>

                <div className="approval-total">

                    <span>

                        Total Pending

                    </span>

                    <strong>

                        {totalPending}

                    </strong>

                </div>

                <Button
                    variant="primary"
                    onClick={() =>
                        navigate("/admin/providers")
                    }
                >
                    View All
                </Button>

            </div>

        </Card>

    );

}

export default PendingProviders;